export async function fetchWarehouses(token) {
  try {

    const headers = { Accept: 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;

    const response = await fetch("https://woh-crm.worldofheels.com.ua/v1/warehouse/warehouse", {
      method: 'GET',
      headers,
    });
    
    if (!response.ok) {
      throw new Error(`Ошибка: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Ошибка при получении складов:", error);
    throw error;
  }
}